import { render } from "./CommercialServicePage.vue?vue&type=template&id=283a3b19"
import script from "./CommercialServicePage.vue?vue&type=script&lang=js"
export * from "./CommercialServicePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__